import React, { useState } from 'react';

export default function LoginPage({ onLogin, loading }) {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(username, password);
  };

  return (
    <div className="login-card">
      <h2>🔐 Admin Dashboard</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Usuario</label>
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" disabled={loading} />
        </div>
        <div className="form-group">
          <label>Contraseña</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" disabled={loading} autoFocus />
        </div>
        <button type="submit" className="btn-primary" disabled={loading || !username || !password}>
          {loading ? 'Conectando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
